import { useState, useEffect } from "react";
import { useLang } from "../../core/lang";
import LangKeys from "../../core/locales/keys";

function LanguageModal({ open = true, onClose, onSaved }) {
  const { lang, setLang, t } = useLang();
  const [selected, setSelected] = useState(lang);

  useEffect(() => {
    setSelected(lang);
  }, [lang]);

  if (!open) return null;

  const languages = [
    { code: "en", short: "En", label: t(LangKeys.english) },
    { code: "hi", short: "हि", label: t(LangKeys.hindi) },
    { code: "en_in", short: "Hi", label: t(LangKeys.hinglish) },
    { code: "gu", short: "ગુ", label: t(LangKeys.gujarati) },
    { code: "mr", short: "म", label: t(LangKeys.marathi) },
    { code: "pa", short: "ਪੰ", label: t(LangKeys.punjabi) },
    { code: "ta", short: "த", label: t(LangKeys.tamil) },
    { code: "te", short: "తె", label: t(LangKeys.telugu) },
  ];

  const saveLanguage = async () => {
    setLang(selected);
    try {
      const token = localStorage.getItem('token') || localStorage.getItem('auth_token');
      if (token) {
        await fetch('https://khata.moxpal.com/api/v2/whatsapp/language', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${token}`,
          },
          body: JSON.stringify({ lang: selected }),
        });
      }
    } catch (e) {
      console.error('Failed to sync language to server:', e);
    }
    onSaved?.(selected);
    onClose?.();
  };

  return (
    <div style={styles.overlay}>
      <div style={styles.modal}>
        <div style={styles.title}>🌐 {t(LangKeys.select_language)}</div>

        <div style={styles.grid}>
          {languages.map((item) => {
            const active = selected === item.code;

            return (
              <button
                key={item.code}
                onClick={() => setSelected(item.code)}
                style={{
                  ...styles.langBtn,
                  ...(active ? styles.langBtnActive : {}),
                }}
              >
                <div
                  style={{
                    ...styles.shortBox,
                    ...(active ? styles.shortBoxActive : {}),
                  }}
                >
                  {item.short}
                </div>

                <span style={styles.label}>{item.label}</span>
              </button>
            );
          })}
        </div>

        <div style={styles.footer}>
          <button style={styles.closeBtn} onClick={onClose}>
            {t(LangKeys.close)}
          </button>

          <button style={styles.saveBtn} onClick={saveLanguage}>
            {t(LangKeys.save)}
          </button>
        </div>
      </div>
    </div>
  );
}

const styles = {
  overlay: {
    position: "fixed",
    inset: 0,
    background: "rgba(15,23,42,0.45)",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    zIndex: 3000,
    padding: "16px",
  },

  modal: {
    width: "100%",
    maxWidth: "430px",
    background: "#fff",
    borderRadius: "22px",
    padding: "20px",
    boxShadow: "0 20px 50px rgba(0,0,0,0.18)",
  },

  title: {
    fontSize: "18px",
    fontWeight: "700",
    color: "#111827",
    textAlign: "center",
    marginBottom: "18px",
  },

  grid: {
    display: "grid",
    gridTemplateColumns: "1fr 1fr",
    gap: "12px",
  },

  langBtn: {
    height: "56px",
    borderRadius: "14px",
    border: "1px solid #D1D5DB",
    background: "#fff",
    display: "flex",
    alignItems: "center",
    gap: "10px",
    padding: "0 12px",
    cursor: "pointer",
  },

  langBtnActive: {
    border: "1px solid #2563EB",
    background: "#EFF6FF",
  },

  shortBox: {
    width: "32px",
    height: "32px",
    borderRadius: "8px",
    background: "#F1F5F9",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    fontWeight: "700",
    color: "#111827",
    flexShrink: 0,
  },

  shortBoxActive: {
    background: "#DBEAFE",
    color: "#1D4ED8",
  },

  label: {
    fontSize: "14px",
    fontWeight: "600",
    color: "#111827",
  },

  footer: {
    display: "flex",
    gap: "12px",
    marginTop: "18px",
  },

  closeBtn: {
    flex: 1,
    height: "44px",
    borderRadius: "14px",
    border: "1px solid #E5E7EB",
    background: "#fff",
    color: "#374151",
    fontSize: "14px",
    fontWeight: "600",
    cursor: "pointer",
  },

  saveBtn: {
    flex: 1,
    height: "44px",
    borderRadius: "14px",
    border: "none",
    background: "#2563EB",
    color: "#fff",
    fontSize: "14px",
    fontWeight: "600",
    cursor: "pointer",
  },
};

export default LanguageModal;